export default __webpack_public_path__ + "static/MarkNadal_GUN-b41c30c8c27cf557fb3c11e82befb7e3.jpg";